import React from 'react'
import styled from 'styled-components'
import Typography from '../../../components/Typography'
import Button from '../../../components/Button/Button'
import HelmetIcon from '../../../components/Icons/HelmetIcon'
import { theme } from '../../../theme'

const PeopleCard = ({
  person,
  showFollowersCount = false,
  followLabel,
  followingLabel,
  followersCountLabel,
  isPending = false,
  onOpenProfile,
  onToggleFollow
}) => {
  if (!person) return null

  return (
    <Row onClick={() => onOpenProfile(person)}>
      <UserInfo>
        {person.userAvatar ? (
          <AvatarImage src={person.userAvatar} alt="user avatar" />
        ) : (
          <AvatarPlaceholder>
            <HelmetIcon width={20} height={20} fill={theme.colors.defaultStrong} />
          </AvatarPlaceholder>
        )}

        <UserText>
          <Typography $variant="body-1-medium" $variantMobile="body-2-medium" color={theme.colors.defaultStrong}>
            {`${person.name || ''} ${person.lastName || ''}`.trim()}
          </Typography>
          {showFollowersCount && (
            <Typography $variant="caption-medium" color={theme.colors.defaultWeak}>
              {followersCountLabel(Number(person.followersCount || 0))}
            </Typography>
          )}
        </UserText>
      </UserInfo>

      <Button
        $variant={person.isFollowing ? 'outline' : 'default'}
        size="m"
        sizeTablet="m"
        sizeMobile="s"
        disabled={isPending}
        onClick={event => {
          event.stopPropagation()
          onToggleFollow(person)
        }}
      >
        {person.isFollowing ? followingLabel : followLabel}
      </Button>
    </Row>
  )
}

export default PeopleCard

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.sizing.sm};
  border-bottom: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  padding: ${({ theme }) => theme.sizing.sm};
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 12px;
  }
`

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.xs};
  min-width: 0;
`

const UserText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

const AvatarImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.radius.xs};
  object-fit: cover;
`

const AvatarPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.radius.xs};
  background-color: ${({ theme }) => theme.fill.defaultWeak};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`
